import React from 'react';
import { Button } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import useWidth from '../../../../Hooks/useWidth';
import { editPostPath } from '../../../../Utils/routes';

function UpdateMyIdeaButton({ post, space }: any) {
  const isMobile = useWidth('down', 'sm');
  const path = editPostPath(space.slug, post.slug, post.type);
  const canEditPost = post.permissions.can_edit_post;

  return (
    <Button
      size="large"
      variant="outlined"
      color="primary"
      fullWidth={isMobile}
      disabled={!canEditPost}
      to={path}
      component={Link}
    >
      <FormattedMessage id="POSTS.DETAILS.UPDATE_MY_IDEA" />
    </Button>
  );
}

export default UpdateMyIdeaButton;
